import { CreateNewCSVoucherForm } from './create-new-customer-service-voucher-form'

export const CreateNewCSVoucherMainNZ = ({
  onCloseModal,
}: {
  onCloseModal: () => void
}) => {
  return <CreateNewCSVoucherForm onCloseModal={onCloseModal} />
}
